// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-event-checkout-by-id-request-schema',
  type: 'object',
  required: ['eventId', 'id'],
  properties: {
    eventId: {
      type: 'string',
      format: 'uuid',
    },
    id: {
      type: 'string',
      format: 'uuid',
    },
  },
} as IJSONSchema;

export default schema;
